export const randomSession = function(len: number = 3): string {
  return Math.random()
    .toString(36)
    .substring(len);
};
